class DateFormat {
  formatDate(date) {
    return new Intl.DateTimeFormat("id-ID", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(new Date(date));
  }

  formatISODate(isoDate: Date | string) {
    // Parsing tanggal asli
    const originalDate: Date = new Date(isoDate);

    // Mengonversi ke zona waktu lokal
    const localDate: Date = new Date(
      originalDate.toLocaleString("en-US", {
        timeZone: "Asia/Jakarta"
      })
    );

    // Membuat format yang diinginkan
    const formattedDate: string =
      localDate.toISOString().split("T")[0] +
      " " +
      localDate
        .toTimeString()
        .split(" ")[0]
        .slice(0, 5);

    return formattedDate;
  }
}
export default new DateFormat();
